module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/997a4f7e19351aa4fe4bc6048e54a9c6.png";